import type { Profile } from '@/features/profile';

import type { SupportTicketRole } from '../model/support-ticket';

/** Derive the persona to record on a ticket the user is about to file, based on
 * their currently active mode (D-014) and profile flags. Never returns 'system'
 * — that's reserved for auto-created tickets. */
export function deriveRoleAtCreation(
  profile: Pick<
    Profile,
    'isImam' | 'isMuezzin' | 'isAppointed' | 'isFreelance' | 'isAdmin' | 'isCertifier'
  >,
  activeMode: 'freelance' | 'appointed' | 'admin' | null,
): SupportTicketRole {
  if (activeMode === 'admin' && profile.isAdmin) return 'admin';
  if (activeMode === 'appointed' && profile.isAppointed) return 'manager';
  if (activeMode === 'freelance' && (profile.isImam || profile.isMuezzin)) return 'freelancer';
  if (profile.isAdmin) return 'admin';
  if (profile.isAppointed) return 'manager';
  if (profile.isImam || profile.isMuezzin) return 'freelancer';
  if (profile.isCertifier) return 'certifier';
  return 'requester';
}
